import { Injectable } from '@angular/core';

import { ConfigService } from '../config.service';

@Injectable()
export class HereMapService {
  private readonly HERE_API_KEY: string;

  constructor(private configService: ConfigService) {
    this.HERE_API_KEY = this.configService.get('HERE_API_KEY');
  }

  getMapLayer(scheme: 'normal' | 'terrain' | 'satellite' | 'hybrid'): string {
    const loadBalancing: 1 | 2 | 3 | 4 = 1;
    const baseUrl = `https://maps.hereapi.com/v3/base/mc`;
    const format: 'png' | 'png8' | 'jpeg' = scheme === 'satellite' || scheme === 'hybrid' ? 'jpeg' : 'png8';
    const authent = `apiKey=${this.HERE_API_KEY}`;
    const ppi = `&ppi=200`;
    const size = `&size=512`;

    return `${baseUrl}/{z}/{x}/{y}/${format}?style=explore.day&${authent}${ppi}${size}`;
  }
}
